<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BaQnwd/tc-custom/9781649794482.jpg?1705540371720" alt="This image is the cover for the book Adonia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Adonia
      </h1>
      <p class="bookDescription body article font2">
        <p>Humanity has made astonishing technological and scientific progress over the last century. But what risks being lost is a proper appreciation of <em>how </em>all progress came to pass, what made it possible. Many of the great minds who helped to propel us into the modern age did so through quiet introspection and deep thinking. <em>Adonia</em> offers the reader the chance to step back to this form of reflective engagement.</p><p><br/></p><p>If we may only venture towards truth once we inherit the willingness to explore it, <em>Adonia</em>’s verses are a depiction of such an inheritance. The work itself is a collection of thoughts, all of which narrate discovery with unharmed truth. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cesare J. Stellato
      </h2>
      
      <p class="authorDescription body article"><p style="margin: 0cm 0cm 0.0001pt; font-size: 15px; font-family: Calibri, sans-serif; text-align: justify;"><span style='font-family:"Times New Roman",serif;'>As a boy, Cesare J. Stellato always seemed to emit a presence of curiosity. His mother would force him out of his thoughts and into the world, but he always admired the playground inside his mind more than the one near his childhood home. In many ways he&rsquo;s still that curious boy, only now the playground is boundless. Until recently, he didn&rsquo;t think he&rsquo;d ever release a collection of writing, but certain events compelled him to share his story.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><br></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Individuals born with a hearing disability tend to develop an overtly observant nature. Being one of those individuals, the world reveals itself to Cesare J. Stellato through a more magnified lens. This inherent quality has become the catalyst of his engagement with the world, acting as the foundation of his character. If deliberate attention to detail wanders, relevant information may be misconstrued, thus diminishing the value of a potential lesson. Still and all, observation has become such a significant aspect of his identity that it has transcended from the physical to the self.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><br></p><p><span style='font-size:15px;font-family:"Times New Roman",serif;'>When self-observation serves as the foundation of one&rsquo;s identity, discovery is an inward experience where the contention between what is and what could be finds peace in the process. <em>Adonia</em>, above all else, is the peace and the process.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7323b775